/**
 * Config API. Calls GET /api/v1/config for tenancy mode etc.
 * Safe default on error so UI works when endpoint is missing.
 */

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api/v1';

const DEFAULT_CONFIG = { tenancy: 'self_hosted' };

/**
 * Fetch app config (e.g. tenancy mode). No auth.
 * @returns {Promise<{ tenancy: 'managed'|'self_hosted' }>}
 */
export async function fetchConfig() {
  const url = `${API_BASE_URL}${API_BASE_URL.endsWith('/') ? '' : '/'}config`;
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    const response = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    });
    clearTimeout(timeoutId);
    const contentType = response.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      return DEFAULT_CONFIG;
    }
    const data = await response.json();
    if (!response.ok) {
      return DEFAULT_CONFIG;
    }
    const tenancy = data.tenancy === 'managed' ? 'managed' : 'self_hosted';
    return { tenancy };
  } catch {
    return DEFAULT_CONFIG;
  }
}
